// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

class Event extends React.Component {
	constructor( props ) {
		super( props )
	}

	componentDidMount() {
		const { page } = this.props

		const location = document.querySelector( '#field_event_rsvp_location' )
		const date = document.querySelector( '#field_event_rsvp_date' )

		if ( location ) {
			location.value = page.event_location
		}

		if ( date ) {
			date.value = page.event_date
		}
	}

	renderContent() {
		const { page } = this.props

		return (
			<div className="event-form">
				<h2>RSVP</h2>

				<div className="-inner" dangerouslySetInnerHTML={ { __html: page.form_html } }></div>
			</div>
		)
	}

	render() {
		return (
			<div className="event">
				{ this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( Event )
